import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const verveCoffeeSuperSackLabelFileDataSchema = yup.object().shape({
  blend: yup.string().nullable().optional(),
  orderType: yup.string().nullable().optional(),
  fulfillmentRequest: yup.string().nullable().optional(),
  barcode: yup.string().nullable().optional(),
})

export type VerveCoffeeSuperSackLabelFileData = yup.InferType<
  typeof verveCoffeeSuperSackLabelFileDataSchema
>
type RequiredFileData = MakeRequiredAndNullable<VerveCoffeeSuperSackLabelFileData>

export const verveCoffeeSuperSackLabelFileMappings: RequiredFileData = {
  blend: '44002d80-2c1f-4694-aa47-d2ba005ca03e',
  orderType: 'c71c60ff-6eb7-4a5c-8376-2aaaeea0680a',
  fulfillmentRequest: '6624517d-5ead-49da-ae76-6547d9650de6',
  barcode: 'd4e5f6a7-b8c9-4adb-e2f3-a4b5c6d7e8f9',
}
